import { getSessionPanelStorage } from '@shared/panels/panelSessionState';

export const MEDIA_GALLERY_CARD_ZOOM_MIN_PERCENT = 100;
export const MEDIA_GALLERY_CARD_ZOOM_MAX_PERCENT = 250;
export const MEDIA_GALLERY_CARD_ZOOM_DEFAULT_PERCENT = 100;
export const MEDIA_GALLERY_CARD_ZOOM_STEP_PERCENT = 10;

export const MEDIA_GALLERY_CARD_ZOOM_SESSION_KEY = 'media-gallery.card-zoom-percent';

export const clampMediaGalleryCardZoomPercent = (value: number): number => {
    if (Number.isNaN(value)) {
        return MEDIA_GALLERY_CARD_ZOOM_DEFAULT_PERCENT;
    }

    return Math.min(
        MEDIA_GALLERY_CARD_ZOOM_MAX_PERCENT,
        Math.max(MEDIA_GALLERY_CARD_ZOOM_MIN_PERCENT, Math.round(value))
    );
};

export const loadMediaGalleryCardZoomPercent = (key: string): number => {
    const storage = getSessionPanelStorage();
    const rawValue = storage?.getItem(key);

    return clampMediaGalleryCardZoomPercent(rawValue ? Number(rawValue) : MEDIA_GALLERY_CARD_ZOOM_DEFAULT_PERCENT);
};

export const saveMediaGalleryCardZoomPercent = (key: string, value: number): number => {
    const normalizedValue = clampMediaGalleryCardZoomPercent(value);
    const storage = getSessionPanelStorage();

    if (storage) {
        storage.setItem(key, String(normalizedValue));
    }

    return normalizedValue;
};